import React from 'react';
import PropTypes from 'prop-types';

import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import { useMenu } from 'bento-ordering/context/MenuContext';

function MenuItemNotOnCurrentMenuFilteredItemNotification({ closeModal }) {
  const { resetFilteredPromoId } = useMenu();

  const handleCloseModal = () => {
    resetFilteredPromoId();
    closeModal();
  };

  return (
    <NotificationModal
      title="Oops! This promotion is not currently available"
      body="Please try again at another time. Be aware that item availability may have changed."
      onClose={handleCloseModal}
      fullWidth
    >
      <PrimaryCta label="OK, Got It" handleClick={handleCloseModal} fullWidth />
    </NotificationModal>
  );
}

MenuItemNotOnCurrentMenuFilteredItemNotification.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default MenuItemNotOnCurrentMenuFilteredItemNotification;
